function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { getInitialResults } from "instantsearch.js/es/lib/server.js";
import { resetWidgetId, walkIndex } from "instantsearch.js/es/lib/utils/index.js";
import { ServerInsertedHTMLContext } from "next/navigation.js";
import { useContext } from 'react';
import { useInstantSearchContext, useRSCContext, wrapPromiseWithState } from 'react-instantsearch-core';
import { createInsertHTML } from "./createInsertHTML.js";
export function InitializePromise(_ref) {
  var nonce = _ref.nonce;
  var _search = useInstantSearchContext();
  var _useRSCContext = useRSCContext(),
    waitForResultsRef = _useRSCContext.waitForResultsRef;
  var insertHTML = useContext(ServerInsertedHTMLContext) || function () {
    throw new Error('Missing ServerInsertedHTMLContext');
  };

  // Extract search parameters from the search client to use them
  // later during hydration.
  var requestParamsList;
  if (_search.compositionID) {
    _search.mainHelper.setClient(_objectSpread(_objectSpread({}, _search.mainHelper.getClient()), {}, {
      search: function search(query) {
        requestParamsList = [query.requestBody.params];
        return _search.client.search(query);
      }
    }));
  } else {
    _search.mainHelper.setClient(_objectSpread(_objectSpread({}, _search.mainHelper.getClient()), {}, {
      search: function search(queries) {
        requestParamsList = queries.map(function (_ref2) {
          var params = _ref2.params;
          return params;
        });
        return _search.client.search(queries);
      }
    }));
  }
  resetWidgetId();
  var waitForResults = function waitForResults() {
    return new Promise(function (resolve) {
      var searchReceived = false;
      var recommendReceived = false;
      _search.mainHelper.derivedHelpers[0].once('result', function () {
        searchReceived = true;
        if (!_search._hasRecommendWidget || recommendReceived) {
          resolve();
        }
      });
      _search.mainHelper.derivedHelpers[0].once('recommend:result', function () {
        recommendReceived = true;
        if (!_search._hasSearchWidget || searchReceived) {
          resolve();
        }
      });
    });
  };
  var injectInitialResults = function injectInitialResults() {
    var options = {
      inserted: false
    };
    var results = getInitialResults(_search.mainIndex, requestParamsList);
    insertHTML(createInsertHTML({
      options: options,
      results: results,
      nonce: nonce
    }));
  };
  if ((waitForResultsRef === null || waitForResultsRef === void 0 ? void 0 : waitForResultsRef.current) === null) {
    waitForResultsRef.current = wrapPromiseWithState(waitForResults().then(function () {
      var shouldRefetch = false;
      walkIndex(_search.mainIndex, function (index) {
        shouldRefetch = index.getWidgets().some(function (widget) {
          return widget.$$type === 'ais.dynamicWidgets';
        });
      });
      if (shouldRefetch) {
        var _search$_resetSchedul;
        (_search$_resetSchedul = _search._resetScheduleSearch) === null || _search$_resetSchedul === void 0 ? void 0 : _search$_resetSchedul.call(_search);
        waitForResultsRef.current = wrapPromiseWithState(waitForResults().then(injectInitialResults));
      }
      return shouldRefetch;
    }).then(function (shouldRefetch) {
      if (shouldRefetch) {
        return;
      }
      injectInitialResults();
    }));
  }
  return null;
}